import { useState } from "react";

import { Checkbox } from "./ui/Checkbox";

export default function FilterCheckboxGroup({ name, value, values, onChange }) {
  const [data, setData] = useState(value ? value.split(",") : []);

  const onUpdate = (k, state) => {
    let d = [...data];

    if (state) {
      d.push(k);
    } else {
      d = d.filter((s) => s != k);
    }

    setData(d);
    onChange(name, d.length > 0 ? d.join(",") : "");
  };

  return (
    <div className="flex flex-col gap-3">
      {Object.entries(values).map(([key, val]) => (
        <div key={key} className="flex items-center gap-3">
          <Checkbox
            id={val.value}
            defaultChecked={!!value?.split(",").find((e) => e === val.value)}
            onCheckedChange={(e) => {
              console.log(val.value, e);
              onUpdate(val.value, e);
            }}
          />
          <label htmlFor={val.value} className="cursor-pointer leading-none">
            {val.title}
          </label>
        </div>
      ))}
    </div>
  );
}
